(function () {
  var s = document.getElementById('quick-order-entry');
  if (!s) return;

  var root   = s.dataset.root || '/',
      limit  = +s.dataset.suggestLimit || 10,
      prefix = s.dataset.usePrefix === 'true',
      input  = s.querySelector('#qe-input'),
      list   = s.querySelector('#qe-suggestions'),
      qty    = s.querySelector('#qe-qty'),
      add    = s.querySelector('#qe-add'),
      msg    = s.querySelector('#qe-msg'),
      chosen = null,
      cache  = {};

  function deb(fn, t) { var id; return function () { clearTimeout(id); id = setTimeout(fn.bind(this, ...arguments), t); }; }

  function prodJs(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root + 'products/' + handle + '.js')
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(j => (cache[handle] = j));
  }

  function render(items) {
    list.innerHTML = items.length
      ? items.map(i => `<li data-id="${i.id}">${i.label}</li>`).join('')
      : '<li>No results</li>';
    list.classList.remove('hidden');
  }

  function bestVariants(term) {
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(term) +
              '&resources[type]=product&resources[limit]=' + limit +
              (prefix ? '&options[prefix]=last' : '') +
              '&resources[options][fields]=title,variants.title,variants.sku';

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(j => j.resources.results.products || [])
      .then(ps => Promise.all(ps.map(p => prodJs(p.handle))));
  }

  function defaultProducts() {
    return fetch(root + 'products.json?limit=' + limit)
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(j => j.products || []);
  }

  function toItems(products) {
    var out = [];
    products.forEach(p => p.variants.forEach(v => {
      var sku   = v.sku ? ' ' + v.sku + '' : '',
      label =   sku + ': '  + p.title;

      out.push({ id: v.id, label });
    }));
    return out;
  }

  var suggest = deb(function () {
    var t = input.value.trim(); chosen = null;
    if (!t) { list.classList.add('hidden'); return; }
    bestVariants(t).then(toItems).then(render).catch(() => render([]));
  }, 250);

  input.addEventListener('input', suggest);
  input.addEventListener('focus', function () {
    if (input.value.trim()) return;
    defaultProducts().then(toItems).then(render).catch(() => render([]));
  });

  list.addEventListener('click', e => {
    var li = e.target.closest('li');
    if (!li) return;
    chosen = li.dataset.id;
    input.value = li.textContent;
    list.classList.add('hidden');
  });

  function refreshCart() {
    var ids = ['main-cart-items', 'main-cart-footer', 'cart-live-region-text'],
        url = location.pathname + '?sections=' + ids.join(',');
    fetch(url).then(r => r.json()).then(h => {
      ids.forEach(id => {
        var tgt = document.getElementById(id), html = h[id];
        if (!tgt || !html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var src = tmp.querySelector('.js-contents') || tmp.firstElementChild,
            dst = tgt.querySelector('.js-contents') || tgt;
        if (src && dst) dst.innerHTML = src.innerHTML;
      });
      document.dispatchEvent(new Event('cart:updated'));
    });
  }

  function updateBubble() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(c => {
        var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (!b) return;
        var v = c.item_count;
        b.classList.toggle('hidden', !v);
        b.querySelector('span[aria-hidden="true"]').textContent = v;
        b.querySelector('.visually-hidden').textContent = v + ' items';
      });
  }

  add.addEventListener('click', function () {
    var q = +qty.value || 1;
    if (!chosen) { msg.textContent = 'Select a variant first'; return; }

    add.disabled = true; msg.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: chosen, quantity: q })
    })
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(item => {
        msg.textContent = 'Added ' + q + ' × ' + item.title;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (window.publish && window.PUB_SUB_EVENTS)
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-order-entry' });
        refreshCart();
        updateBubble();
      })
      .catch(() => msg.textContent = 'Could not add')
      .finally(() => add.disabled = false);
  });
})();
